export default __webpack_public_path__ + "static/media/pluses5.b35f2ae8.png";